export default "__VITE_ASSET__B_gS1Nm5__"